'use client';

import { useXpStatus, useXpConfig, useLevelBonuses, useClaimLevelBonus } from '../../queries/useProfileQueries';

export const useLevelInfoScreenData = () => {
  const { data: xpStatus, isLoading: isLoadingXpStatus } = useXpStatus();
  const { data: xpConfig, isLoading: isLoadingXpConfig } = useXpConfig();
  const { data: levelBonuses, isLoading: isLoadingLevelBonuses } = useLevelBonuses();

  const claimLevelBonusMutation = useClaimLevelBonus();

  const loading = isLoadingXpStatus || isLoadingXpConfig || isLoadingLevelBonuses;

  const claimLevelBonus = async (level: number) => {
    await claimLevelBonusMutation.mutateAsync(level);
  };

  return {
    xpStatus,
    xpConfig,
    levelBonuses,
    loading,
    error: null,
    loadData: () => {},
    claimLevelBonus,
    claimingLevel: claimLevelBonusMutation.isPending ? 0 : null,
  };
};
